// extracted by mini-css-extract-plugin
export default {"form-input":"FormInput_form-input__qmwl7","form-input-field":"FormInput_form-input-field__Hw9kk","form-input-label":"FormInput_form-input-label__ohkjE"};